module.exports = __webpack_public_path__ + "img/anneso.b097c1a3.jpg";